import { Fragment } from 'react';

export function RelianceOnInformation() {
  return (
    <Fragment>
      The materials contained on our site are provided for general information purposes only and do not claim to be or constitute legal or other professional advice and shall not be relied upon as such for any reason.  
      <br /><br />
      We do not accept any responsibility for any loss which may arise from accessing or reliance on the information on this site and to the fullest extent permitted by English law, we exclude all liability for loss or damages whether direct or indirect arising from use of this site.
      <br /><br />
      Where our site contains links to other sites and resources provided by third parties, these links are provided for your information only. We have no control over the contents of those sites or resources, and accept no responsibility for them or for any loss or damage that may arise from your use of them. When accessing a site via our website we advise you to check their terms of use and privacy policies to ensure compliance and determine how they may use your information.
    </Fragment>
  );
}


export default RelianceOnInformation;
